// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__33ybs","icon":"style_icon__cgoyK","header-content":"style_header-content__2YpKv","title":"style_title__2qF4b","subtitle":"style_subtitle__2Se9q"};